export default "__VITE_ASSET__Dd1I7Bs5__"